import { Roles } from "../constants/roles";
import { FormBase } from "../util/form-base-form";

export class NotificationsForm extends FormBase {
    public getTrigger(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, ".navbar-notifications", HTMLElement);
    }

    public getPopover(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.NOTIFICATIONS_POPOVER}"]`, HTMLElement);
    }

    public getLoading(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.NOTIFICATIONS_POPOVER_LOADING}"]`, HTMLElement);
    }

    public getList(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.NOTIFICATIONS_POPOVER_LIST}"]`, HTMLElement);
    }

    public getEmpty(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.NOTIFICATIONS_POPOVER_EMPTY}"]`, HTMLElement);
    }

    public getBadge(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.NOTIFICATIONS_UNREAD_BADGE}"]`, HTMLElement);
    }

    public getCloseButton(root: ParentNode): HTMLElement | null {
        return this.queryElement(root, ".js-notifications-popover-close", HTMLElement);
    }

    public getOverlay(root: ParentNode = document): HTMLElement | null {
        return this.queryElement(root, `[data-role="${Roles.NOTIFICATIONS_OVERLAY}"]`, HTMLElement);
    }

    public getNotificationItems(root: ParentNode): HTMLElement[] {
        return this.queryElements(root, ".navbar-notification-item[data-notification-id]", HTMLElement);
    }

    public getClosestAnchor(target: EventTarget | Element | null | undefined): HTMLAnchorElement | null {
        return this.closest(target, "a", HTMLAnchorElement);
    }
}

export const notificationsForm = new NotificationsForm();
